<div class="theme-page">
    <div *ngIf="themes.length > 0" class="theme-container">
        <div
            class="theme-card"
            *ngFor="let theme of themes; let i = index"
            [ngClass]="{ active: theme.id == catalogLayoutConfig.themeId }"
        >
            <div class="theme-details">
                <p class="upper-text font-bold">{{ theme.name }}</p>
                <p>{{ theme.header }}</p>
                <div class="theme-btn">
                    <button class="c-btn c-btn--short c-btn--primary" (click)="useTheme(theme)">Use</button>
                    <button
                        class="c-btn c-btn--short c-btn--primary"
                        (click)="customizeTheme(theme, $event)"
                        *ngIf="themes.length == 4 || theme.id == 0"
                    >
                        Customize
                    </button>
                </div>
            </div>
            <div class="theme-box">
                <div class="half">
                    <ul class="colors-list">
                        <li>
                            <i [attr.aria-label]="theme.config.accent"
                                class="accent-color"
                                [ngStyle]="{ 'background-color': theme.config.accent, color: theme.config.accent }"

                            ></i>
                            <span>Accent Color</span>
                        </li>
                        <li>
                            <i [attr.aria-label]="theme.config.background"
                                class="main-color"
                                [ngStyle]="{
                                    'background-color': theme.config.background,
                                    color: theme.config.background
                                }"
                            ></i>
                            <span>Background Color</span>
                        </li>
                        <li>
                            <i [attr.aria-label]="theme.config.type_1"
                                class="secondary-color"
                                [ngStyle]="{ 'background-color': theme.config.type_1, color: theme.config.type_1 }"
                            ></i>
                            <span>Type 1</span>
                        </li>
                        <li>
                            <i [attr.aria-label]="theme.config.type_2"
                                class="hilite-color"
                                [ngStyle]="{ 'background-color': theme.config.type_2, color: theme.config.type_2 }"
                            ></i>
                            <span>Type 2</span>
                        </li>
                    </ul>
                </div>
                <div class="half pages">
                    <div class="page-small">
                        <div
                            class="header main-color"
                            [ngStyle]="{
                                'background-color': theme.config.accent,
                                color: theme.config.accent
                            }"
                        ></div>
                        <ul class="content-list">
                            <li
                                class="accent-color hilite-color-hover"
                                [ngStyle]="{ 'background-color': theme.config.type_1, color: theme.config.type_1 }"
                            ></li>
                            <li
                                class="accent-color hilite-color-hover"
                                [ngStyle]="{ 'background-color': theme.config.type_1, color: theme.config.type_1 }"
                            ></li>
                            <li
                                class="accent-color hilite-color-hover"
                                [ngStyle]="{ 'background-color': theme.config.type_1, color: theme.config.type_1 }"
                            ></li>
                            <li
                                class="accent-color hilite-color-hover"
                                [ngStyle]="{ 'background-color': theme.config.type_1, color: theme.config.type_1 }"
                            ></li>
                            <li
                                class="accent-color hilite-color-hover"
                                [ngStyle]="{ 'background-color': theme.config.type_2, color: theme.config.type_2 }"
                            ></li>
                            <li
                                class="accent-color hilite-color-hover"
                                [ngStyle]="{ 'background-color': theme.config.type_1, color: theme.config.type_1 }"
                            ></li>
                            <li
                                class="accent-color hilite-color-hover"
                                [ngStyle]="{ 'background-color': theme.config.type_1, color: theme.config.type_1 }"
                            ></li>
                            <li
                                class="accent-color hilite-color-hover"
                                [ngStyle]="{ 'background-color': theme.config.type_1, color: theme.config.type_1 }"
                            ></li>
                            <li
                                class="accent-color hilite-color-hover"
                                [ngStyle]="{ 'background-color': theme.config.type_1, color: theme.config.type_1 }"
                            ></li>
                            <li
                                class="accent-color hilite-color-hover"
                                [ngStyle]="{ 'background-color': theme.config.type_1, color: theme.config.type_1 }"
                            ></li>
                        </ul>
                    </div>
                    <div class="page-big">
                        <div class="header">
                            <div
                                class="b-btn accent-color"
                                [ngStyle]="{ 'background-color': theme.config.accent, color: theme.config.accent }"
                            ></div>
                            <div aria-hidden="true"
                                class="b-btn main-color"
                                [ngStyle]="{
                                    'background-color': theme.config.background,
                                    color: theme.config.background,
                                    background: 'url(theme.config.header)'
                                }"
                            ></div>
                        </div>
                        <div class="page-content">
                            <div
                                class=" secondary-color big"
                                [ngStyle]="{
                                    'background-color': theme.config.background,
                                    color: theme.config.background
                                }"
                            ></div>
                            <div
                                class=" secondary-color mid"
                                [ngStyle]="{
                                    'background-color': theme.config.background,
                                    color: theme.config.background
                                }"
                            ></div>
                            <div
                                class=" secondary-color mid"
                                [ngStyle]="{
                                    'background-color': theme.config.background,
                                    color: theme.config.background,
                                    'margin-top': '8px'
                                }"
                            ></div>
                            <div
                                class=" secondary-color small"
                                [ngStyle]="{
                                    'background-color': theme.config.background,
                                    color: theme.config.background
                                }"
                            ></div>
                            <div
                                class=" secondary-color small"
                                [ngStyle]="{
                                    'background-color': theme.config.background,
                                    color: theme.config.background
                                }"
                            ></div>
                            <div
                                class=" secondary-color small"
                                [ngStyle]="{
                                    'background-color': theme.config.background,
                                    color: theme.config.background
                                }"
                            ></div>
                            <div
                                class=" secondary-color small"
                                [ngStyle]="{
                                    'background-color': theme.config.background,
                                    color: theme.config.background
                                }"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
</div>
